import { IFilterObject } from '../../components/FilterComponent'

const chartColors = ['#004BFF', '#5897FA', '#9DEBF1', '#B3C6F4']
const xAxisOptions = [
  {
    title: 'Month',
    value: 'month',
  },
  {
    title: 'Quarter',
    value: 'quarter',
  },
  {
    title: 'Year',
    value: 'year',
  },
  {
    title: 'State',
    value: 'state',
  },
  {
    title: 'Country',
    value: 'country',
  },
  {
    title: 'Disposition',
    value: 'disposition',
  },
]

const defaultFilter: IFilterObject[] = [
  {
    title: 'Incident Type',
    value: 'incident_types',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Threat',
        value: 'THREAT',
        checked: false,
        section: false,
      },
      {
        title: 'Assault',
        value: 'ASSAULT',
        checked: false,
        section: false,
      },
      {
        title: 'Bullying',
        value: 'BULLYING',
        checked: false,
        section: false,
      },
      {
        title: 'Intimate partner violence',
        value: 'INTIMATE_PARTNER_VIOLENCE',
        checked: false,
        section: false,
      },
      {
        title: 'Stalking',
        value: 'STALKING',
        checked: false,
        section: false,
      },
      {
        title: 'Weapon on company property',
        value: 'WEAPON_ON_COMPANY_PROPERTY',
        checked: false,
        section: false,
      },
      {
        title: 'Concerning communication',
        value: 'INAPPROPRIATE_COMMUNICATION',
        checked: false,
        section: false,
      },
      {
        title: 'Risk of self harm',
        value: 'RISK_OF_SELF_HARM',
        checked: false,
        section: false,
      },
      {
        title: 'Risk to others',
        value: 'RISK_TO_OTHERS',
        checked: false,
        section: false,
      },
      {
        title: 'Anonymous communication',
        value: 'ANONYMOUS_COMMUNICATION',
        checked: false,
        section: false,
      },
      {
        title: 'Vandalism',
        value: 'VANDALISM',
        checked: false,
        section: false,
      },
      {
        title: 'Other',
        value: 'OTHER',
        checked: false,
        section: false,
      },
    ],
  },
  {
    title: 'OSHA Violence Type',
    value: 'violence_types',

    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Criminal Intent',
        value: 'Criminal Intent',
        checked: false,
        section: false,
      },
      {
        title: 'Customer / Client',
        value: 'Customer / Client',
        checked: false,
        section: false,
      },
      {
        title: 'Worker on Worker',
        value: 'Worker on Worker',
        checked: false,
        section: false,
      },
      {
        title: 'Personal Relationship',
        value: 'Personal Relationship',
        checked: false,
        section: false,
      },
    ],
  },
  {
    title: 'Disposition',
    value: 'dispositions',
    section: true,
    checked: false,
    subTypes: [
      {
        title: 'Substantiated',
        value: 'substantiated',
        checked: false,
        section: false,
      },
      {
        title: 'Unsubstantiated',
        value: 'unsubstantiated',
        checked: false,
        section: false,
      },
      {
        title: 'Inconclusive',
        value: 'inconclusive',
        checked: false,
        section: false,
      },
      {
        title: 'Other',
        value: 'other',
        checked: false,
        section: false,
      },
    ],
  },
]

export default {
  chartColors,
  xAxisOptions,
  defaultFilter,
}
